// startup
// Load entry module
__webpack_require__("./src/editor_script.js");
// This entry module used 'exports' so it can't be inlined
